import Web3 from "web3";
import {
  presaleABI,
  alpaTokenABI,
  alpacaABI,
  alpaRewardABI,
  tokenPresaleABI,
  tokenPresaleWLABI,
  masterChefABI,
  fakeLPABI,
  LPABI,
  alpaSupplierABI,
  alpacaSquadABI,
  alpaFireABI,
} from "./abi";
import { contractAddress as alpacaRecycleBox } from "@/contract/alpacaRecycleBox";
import BigNumber from "bignumber.js";
import { EventBus } from "@/utils/EventBus";
import { metaMaskErrorHandler, MetaError } from "@/utils/errorHandler";

export const presaleContractAddress =
  process.env.VUE_APP_PRESALE_CONTRACT_ADDRESS;
export const alpaTokenContractAddress =
  process.env.VUE_APP_ALPA_TOKEN_CONTRACT_ADDRESS;
export const alpacaContractAddress =
  process.env.VUE_APP_ALPACA_CONTRACT_ADDRESS;
export const alpaRewardContractAddress =
  process.env.VUE_APP_ALPA_REWARD_CONTRACT_ADDRESS;
export const tokenPresaleContractAddress =
  process.env.VUE_APP_TOKEN_PRESALE_CONTRACT_ADDRESS;
export const tokenPresaleWLContractAddress =
  process.env.VUE_APP_TOKEN_PRESALE_WL_CONTRACT_ADDRESS;
export const masterChefContractAddress =
  process.env.VUE_APP_MASTER_CHEF_CONTRACT_ADDRESS;
export const masterChefV2ContractAddress =
  process.env.VUE_APP_MASTER_CHEF_V2_CONTRACT_ADDRESS;
export const masterChefV3ContractAddress =
  process.env.VUE_APP_MASTER_CHEF_V3_CONTRACT_ADDRESS;
export const fakeLPContractAddress =
  process.env.VUE_APP_FAKE_LP_CONTRACT_ADDRESS;
export const LPContractAddress = process.env.VUE_APP_LP_CONTRACT_ADDRESS;
export const LPV2ContractAddress = process.env.VUE_APP_LP_V2_CONTRACT_ADDRESS;
export const alpaSupplierContractAddress =
  process.env.VUE_APP_ALPA_SUPPLIER_CONTRACT_ADDRESS;
export const alpacaSquadContractAddress =
  process.env.VUE_APP_ALPACA_SQUAD_CONTRACT_ADDRESS;
export const alpaFireContractAddress =
  process.env.VUE_APP_ALPA_FIRE_CONTRACT_ADDRESS;

let presaleContract: any = null;
let alpaTokenContract: any = null;
let alpacaContract: any = null;
let alpaRewardContract: any = null;
let tokenPresaleContract: any = null;
let tokenPresaleWLContract: any = null;
let masterChefContract: any = null;
let masterChefV2Contract: any = null;
let masterChefV3Contract: any = null;
let LPContract: any = null;
let LPV2Contract: any = null;
let alpaSupplierContract: any = null;
let alpacaSquadContract: any = null;
let alpaFireContract: any = null;

export const loadWeb3 = async (store: any) => {
  if (window.ethereum) {
    try {
      window.web3 = new Web3(Web3.givenProvider);
      const chainID = await window.web3.eth.getChainId();
      store.commit("setChainID", chainID);
      checkAccount(store);
      detectChainChange();
    } catch (err) {
      console.error("ethereum error: ", err);
    }
  } else if (window.web3) {
    try {
      window.web3 = new Web3(window.web3.currentProvider);
      const chainID = await window.web3.eth.getChainId();
      store.commit("setChainID", chainID);
      checkAccount(store);
      detectChainChange();
    } catch (err) {
      console.error("web3 error: ", err);
    }
  } else {
    console.error("Non-Ethereum browser detected. Using Infura fallback.");
    // console.log(Web3.givenProvider)
    // window.alert('No MetaMask detected');
  }
};

export const checkAccount = (store: any) => {
  window.web3.eth.getAccounts().then((accounts: string[]) => {
    // console.log('accounts', accounts);
    if (accounts[0]) {
      store.commit("setAccount", accounts[0]);
    }
  });
};

export const validateAccount = async (vue: Vue) => {
  const account = vue.$store.getters.getAccount;
  if (!account) {
    await initAccount(vue);
  }
};

const initAccount = async (vue: Vue) => {
  // First try EIP 1102 Connect method
  if (window.ethereum) {
    try {
      // Request account access if needed
      // @ts-ignore
      await window.ethereum
        .request({ method: "eth_requestAccounts" })
        .then((wallets: any) => {
          const account = wallets[0];
          vue.$store.commit("setAccount", account);
          // After account is complete, get the balance
          // window.web3.eth.personal.sign('Alpaca City', account).then(console.log);
          // Watch for account change
          // this.pollAccountUpdates();
        });
    } catch (error) {
      // User denied account access...
      console.log("User cancelled connect request. Error:", error);

      // Reject Connect
      // this.rejectAccountConnect(error);
    }
  } else {
    // Revert back to directly getting wallet address
    try {
      const account = window.web3.eth.accounts[0];
      vue.$store.commit("setAccount", account);

      // console.log("wallet address:", account);

      // After account is complete, get the balance

      // Watch for account change
      // TODO: This type of wallet browser probably doesn't inject window.ethereum
      // this.pollAccountUpdates();
    } catch (error) {
      console.error("Could not get account address. Error: ", error);

      // Reject Connect
      // TODO: This needs a new modal
      // this.rejectAccountConnect(error);
    }
  }
};

export const signAccount = async (dataToSign: string, address: string) => {
  if (!window.web3) {
    return;
  }
  try {
    const signature = await window.web3.eth.personal.sign(
      window.web3.utils.utf8ToHex(dataToSign),
      address
    );
    return signature;
  } catch (err) {
    metaMaskErrorHandler(err);
  }
};

export const detectAccountChange = (vue: Vue) => {
  if (window.ethereum) {
    window.ethereum.on("accountsChanged", (accounts: string) => {
      // window.location.reload();
    });
  }
};

export const detectChainChange = () => {
  if (window.ethereum) {
    window.ethereum.on("chainChanged", (chain: string) => {
      window.location.reload();
    });
  }
};

export const getCurBlockNumber = async () => {
  if (window.web3) {
    return await window.web3.eth.getBlockNumber();
  } else {
    return null;
  }
};

// hasMetaMask: () => {
//   let hasMetaMask = false;

//   if (typeof window.ethereum !== "undefined") {
//     hasMetaMask = typeof window.ethereum.isMetaMask !== "undefined";
//   }

//   return hasMetaMask;
// },

export const initPresaleContract = () => {
  if (window.web3 && presaleContract === null) {
    presaleContract = new window.web3.eth.Contract(
      presaleABI,
      presaleContractAddress
    );
  }
};

export const initAlpaTokenContract = () => {
  if (window.web3 && alpaTokenContract === null) {
    alpaTokenContract = new window.web3.eth.Contract(
      alpaTokenABI,
      alpaTokenContractAddress
    );
  }
};

export const initAlpacaContract = () => {
  if (window.web3 && alpacaContract === null) {
    alpacaContract = new window.web3.eth.Contract(
      alpacaABI,
      alpacaContractAddress
    );
  }
};

export const initAlpaRewardContract = () => {
  if (window.web3 && alpaRewardContract === null) {
    alpaRewardContract = new window.web3.eth.Contract(
      alpaRewardABI,
      alpaRewardContractAddress
    );
  }
};

export const initTokenPresaleContract = () => {
  if (window.web3 && tokenPresaleContract === null) {
    tokenPresaleContract = new window.web3.eth.Contract(
      tokenPresaleABI,
      tokenPresaleContractAddress
    );
  }
};

export const initTokenPresaleWLContract = () => {
  if (window.web3 && tokenPresaleWLContract === null) {
    tokenPresaleWLContract = new window.web3.eth.Contract(
      tokenPresaleWLABI,
      tokenPresaleWLContractAddress
    );
  }
};

export const initMasterChefContract = () => {
  if (window.web3 && masterChefContract === null) {
    masterChefContract = new window.web3.eth.Contract(
      masterChefABI,
      masterChefContractAddress
    );
  }
};

export const initMasterChefV2Contract = () => {
  if (window.web3 && masterChefV2Contract === null) {
    masterChefV2Contract = new window.web3.eth.Contract(
      masterChefABI,
      masterChefV2ContractAddress
    );
  }
};

// new LP farm contract 
export const initMasterChefV3Contract = () => {
  if (window.web3 && masterChefV3Contract === null) {
    masterChefV3Contract = new window.web3.eth.Contract(
      masterChefABI,
      masterChefV3ContractAddress
    );
  }
};

export const initLPContract = () => {
  if (window.web3 && LPContract === null) {
    if (LPContractAddress) {
      LPContract = new window.web3.eth.Contract(LPABI, LPContractAddress);
    } else {
      LPContract = new window.web3.eth.Contract(
        fakeLPABI,
        fakeLPContractAddress
      );
    }
  }
};

export const initLPV2Contract = () => {
  if (window.web3 && LPV2Contract === null) {
    if (LPV2ContractAddress) {
      LPV2Contract = new window.web3.eth.Contract(LPABI, LPV2ContractAddress);
    } else {
      LPV2Contract = new window.web3.eth.Contract(
        fakeLPABI,
        fakeLPContractAddress
      );
    }
  }
};

export const initAlpaSupplierContract = () => {
  if (window.web3 && alpaSupplierContract === null) {
    alpaSupplierContract = new window.web3.eth.Contract(
      alpaSupplierABI,
      alpaSupplierContractAddress
    );
  }
};

export const initAlpacaSquadContract = () => {
  if (window.web3 && alpacaSquadContract === null) {
    alpacaSquadContract = new window.web3.eth.Contract(
      alpacaSquadABI,
      alpacaSquadContractAddress
    );
  }
};

export const initAlpaFireContract = () => {
  if (window.web3 && alpaFireContract === null) {
    alpaFireContract = new window.web3.eth.Contract(
      alpaFireABI,
      alpaFireContractAddress
    );
  }
};

export const getAlpaca = async (id: number) => {
  initAlpacaContract();
  try {
    const info = await alpacaContract.methods.getAlpaca(id).call();
    return info;
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const canAdoptCount = async (address: string) => {
  if (!address) {
    return;
  }
  initPresaleContract();
  try {
    const count = await presaleContract.methods.canAdoptCount(address).call();
    return count;
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const getAdoptionPrice = async (count: number) => {
  initPresaleContract();
  try {
    const price = await presaleContract.methods.getAdoptionPrice(count).call();
    return price;
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const adoptAlpaca = async (
  amount: BigNumber,
  count: number,
  address: string
) => {
  initPresaleContract();
  try {
    const res = await presaleContract.methods
      .adoptAlpaca(count)
      .send({
        from: address,
        value: amount,
      })
      .once("sending", () => {
        EventBus.$emit("trx-result", { status: "loading", trxId: "" });
      })
      .once("transactionHash", (hash: string) => {
        EventBus.$emit("trx-result", { status: "completed", trxId: hash });
      })
      .on("error", (err: MetaError) => {
        metaMaskErrorHandler(err);
      });
  } catch (err) {
    metaMaskErrorHandler(err);
  }
};

export const allowance = async (owner: string, spender: string) => {
  initAlpaTokenContract();
  if (!owner) {
    return;
  }
  try {
    const amount = await alpaTokenContract.methods
      .allowance(owner, spender)
      .call();
    return window.web3.utils.fromWei(amount, "ether");
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const balanceOf = async (address: string) => {
  initAlpaTokenContract();
  if (!address) {
    return;
  }
  try {
    const amount = await alpaTokenContract.methods.balanceOf(address).call();
    return window.web3.utils.fromWei(amount, "ether");
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const totalStaked = async () => {
  initAlpaTokenContract();
  try {
    const amount = await alpaTokenContract.methods
      .balanceOf(alpaRewardContractAddress)
      .call();
    return window.web3.utils.fromWei(amount, "ether");
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const hatchingALPACost = async (sireId: number, matronId: number) => {
  initAlpacaContract();
  try {
    const cost = await alpacaContract.methods
      .hatchingALPACost(sireId, matronId)
      .call();
    return window.web3.utils.fromWei(cost, "ether");
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const increaseAllowance = async (
  address: string,
  spender: string,
  addedValue: number
) => {
  initAlpaTokenContract();
  if (!address) {
    return;
  }
  try {
    alpaTokenContract.methods
      .increaseAllowance(
        spender,
        window.web3.utils.toWei(`${addedValue}`, "ether")
      )
      .send({
        from: address,
      })
      .once("transactionHash", (hash: string) => {
        // EventBus.$emit('trx-result', { status: 'completed', trxId: hash });
      })
      .on("error", (error: string) => {
        EventBus.$emit("approve-status", "error");
      })
      .then(() => {
        EventBus.$emit("approve-status", "completed");
      });
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const isOwnerOf = async (address: string, id: number) => {
  initAlpacaContract();
  if (!address) {
    return;
  }
  try {
    const isOwner = await alpacaContract.methods.isOwnerOf(address, id).call();
    return isOwner;
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const hatchWithAuto = async (
  sireId: number,
  matronId: number,
  address: string
) => {
  initAlpacaContract();
  if (!address) {
    return;
  }
  try {
    alpacaContract.methods
      .hatch(matronId, sireId)
      .send({
        from: address,
        value: new BigNumber(0),
      })
      .once("sending", () => {
        EventBus.$emit("trx-result", { status: "loading", trxId: "" });
      })
      .once("transactionHash", (hash: string) => {
        EventBus.$emit("trx-result", {
          status: "completed",
          trxId: hash,
          wording:
            "Transaction Sent! Check My Alpaca page to hatch your baby Alpaca",
        });
      })
      .on("error", (err: MetaError) => {
        metaMaskErrorHandler(err);
      });
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const crack = async (address: string, id: string) => {
  initAlpacaContract();
  if (!address) {
    return;
  }
  try {
    alpacaContract.methods
      .crack(id)
      .send({
        from: address,
        gas: 282000,
      })
      .once("sending", () => {
        EventBus.$emit("trx-result", { status: "loading", trxId: "" });
      })
      .once("transactionHash", (hash: string) => {
        EventBus.$emit("trx-result", { status: "completed", trxId: hash });
      })
      .on("error", (err: MetaError) => {
        metaMaskErrorHandler(err);
      });
  } catch (err) {
    metaMaskErrorHandler(err);
  }
};

export const safeTransferFrom = async (
  from: string,
  to: string,
  id: string
) => {
  initAlpacaContract();
  if (!from) {
    return;
  }
  try {
    alpacaContract.methods
      .safeTransferFrom(from, to, id, 1, 0x00)
      .send({
        from,
      })
      .once("sending", () => {
        EventBus.$emit("trx-result", { status: "loading", trxId: "" });
      })
      .once("transactionHash", (hash: string) => {
        EventBus.$emit("item-transfer", null, "alpaca");
        EventBus.$emit("trx-result", { status: "completed", trxId: hash });
      })
      .on("error", (err: MetaError) => {
        metaMaskErrorHandler(err);
      });
  } catch (err) {
    console.log(err);
  }
};

export const safeBatchTransferFrom = async (
  from: string,
  to: string,
  ids: string[]
) => {
  initAlpacaContract();
  if (!from) {
    return;
  }
  try {
    alpacaContract.methods
      .safeBatchTransferFrom(from, to, ids, Array(ids.length).fill(1), 0x00)
      .send({
        from,
      })
      .once("sending", () => {
        EventBus.$emit("trx-result", { status: "loading", trxId: "" });
      })
      .once("transactionHash", (hash: string) => {
        EventBus.$emit("trx-result", { status: "completed", trxId: hash });
      })
      .on("error", (err: MetaError) => {
        metaMaskErrorHandler(err);
      });
  } catch (err) {
    console.log(err);
  }
};

export const farmerTransfer = async (
  from: string,
  id: string,
  pool: number
) => {
  const address = chooseMasterChefContractAddress(pool);
  await safeTransferFrom(from, address!, id);
};

export const squadBatchTransfer = async (from: string, ids: string[]) => {
  await safeBatchTransferFrom(from, alpacaSquadContractAddress!, ids);
};

export const recycleBatchTransfer = async (from: string, ids: string[]) => {
  await safeBatchTransferFrom(from, alpacaRecycleBox!, ids);
};

export const chooseMasterChefContract = (pool: number) => {
	if (pool === 0) {
		return masterChefContract
	} else if (pool === 1) {
		return masterChefV2Contract
	} else if (pool === 2) {
		return masterChefV3Contract
	}
};

export const chooseMasterChefContractAddress = (pool: number) => {
	if (pool === 0) {
		return masterChefContractAddress
	} else if (pool === 1) {
		return masterChefV2ContractAddress
	} else if (pool === 2) {
		return masterChefV3ContractAddress
	}
};

export const retrieve = async (from: string, pool: number) => {
  initMasterChefContract();
  initMasterChefV2Contract();
  initMasterChefV3Contract();
  const contract = chooseMasterChefContract(pool);
  if (!from) {
    return;
  }
  try {
    contract.methods
      .retrieve()
      .send({
        from,
      })
      .once("sending", () => {
        EventBus.$emit("trx-result", { status: "loading", trxId: "" });
      })
      .once("transactionHash", (hash: string) => {
        EventBus.$emit("item-transfer", null, "alpaca");
        EventBus.$emit("trx-result", { status: "completed", trxId: hash });
      })
      .on("error", (err: MetaError) => {
        metaMaskErrorHandler(err);
      });
  } catch (err) {
    console.log(err);
  }
};

export const deposit = async (
  amount: BigNumber,
  from: string,
  pool: number
) => {
  initMasterChefContract();
  initMasterChefV2Contract();
  initMasterChefV3Contract();
  const contract = chooseMasterChefContract(pool);
  console.log("xx");
  console.log(contract);
  console.log(contract.methods);
  if (!from) {
    return;
  }
  try {
    contract.methods
      .deposit(window.web3.utils.toWei(`${amount}`, "ether"))
      .send({
        from,
      })
      .once("sending", () => {
        EventBus.$emit("trx-result", { status: "loading", trxId: "" });
      })
      .once("transactionHash", (hash: string) => {
        EventBus.$emit("item-transfer", null, "alpaca");
        EventBus.$emit("trx-result", { status: "completed", trxId: hash });
      })
      .on("error", (err: MetaError) => {
        metaMaskErrorHandler(err);
      });
  } catch (err) {
    console.log(err);
  }
};

export const claim = async (from: string, pool: number) => {
  await deposit(new BigNumber(0), from, pool);
};

export const emergencyWithdraw = async (from: string, pool: number) => {
  initMasterChefContract();
  initMasterChefV2Contract();
  initMasterChefV3Contract();
  const contract = chooseMasterChefContract(pool);
  if (!from) {
    return;
  }
  try {
    contract.methods
      .emergencyWithdraw()
      .send({
        from,
      })
      .once("sending", () => {
        EventBus.$emit("trx-result", { status: "loading", trxId: "" });
      })
      .once("transactionHash", (hash: string) => {
        EventBus.$emit("trx-result", { status: "completed", trxId: hash });
      })
      .on("error", (err: MetaError) => {
        metaMaskErrorHandler(err);
      });
  } catch (err) {
    console.log(err);
  }
};

export const withdraw = async (
  amount: BigNumber,
  from: string,
  pool: number
) => {
  initMasterChefContract();
  initMasterChefV2Contract();
  initMasterChefV3Contract();
  const contract = chooseMasterChefContract(pool);
  if (!from) {
    return;
  }
  try {
    contract.methods
      .withdraw(window.web3.utils.toWei(`${amount}`, "ether"))
      .send({
        from,
      })
      .once("sending", () => {
        EventBus.$emit("trx-result", { status: "loading", trxId: "" });
      })
      .once("transactionHash", (hash: string) => {
        EventBus.$emit("trx-result", { status: "completed", trxId: hash });
      })
      .on("error", (err: MetaError) => {
        metaMaskErrorHandler(err);
      });
  } catch (err) {
    console.log(err);
  }
};

export const pendingAlpa = async (address: string, pool: number) => {
  initMasterChefContract();
  initMasterChefV2Contract();
  initMasterChefV3Contract();
  const contract = chooseMasterChefContract(pool);
  if (!address) {
    return;
  }
  try {
    const amount = await contract.methods.pendingAlpa(address).call();
    return window.web3.utils.fromWei(amount, "ether");
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const enter = async (address: string, amount: BigNumber) => {
  initAlpaRewardContract();
  if (!address) {
    return;
  }
  try {
    alpaRewardContract.methods
      .enter(window.web3.utils.toWei(`${amount}`, "ether"))
      .send({
        from: address,
      })
      .once("transactionHash", (hash: string) => {
        EventBus.$emit("trx-result", { status: "completed", trxId: hash });
      })
      .on("error", (err: MetaError) => {
        metaMaskErrorHandler(err);
      });
  } catch (err) {
    metaMaskErrorHandler(err);
  }
};

export const leave = async (address: string, amount: BigNumber) => {
  initAlpaRewardContract();
  if (!address) {
    return;
  }
  try {
    alpaRewardContract.methods
      .leave(window.web3.utils.toWei(`${amount}`, "ether"))
      .send({
        from: address,
      })
      .once("transactionHash", (hash: string) => {
        EventBus.$emit("trx-result", { status: "completed", trxId: hash });
      })
      .on("error", (err: MetaError) => {
        metaMaskErrorHandler(err);
      });
  } catch (err) {
    metaMaskErrorHandler(err);
  }
};

export const xalpaBalanceOf = async (address: string) => {
  initAlpaRewardContract();
  if (!address) {
    return;
  }
  try {
    const amount = await alpaRewardContract.methods.balanceOf(address).call();
    return window.web3.utils.fromWei(amount, "ether");
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const totalSupply = async () => {
  initAlpaRewardContract();
  try {
    const amount = await alpaRewardContract.methods.totalSupply().call();
    return window.web3.utils.fromWei(amount, "ether");
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const tokenPurchase = (amount: number, address: string) => {
  if (!address) {
    return;
  }
  initTokenPresaleContract();
  try {
    tokenPresaleContract.methods
      .purchase()
      .send({
        from: address,
        value: window.web3.utils.toWei(`${amount}`, "ether"),
      })
      .once("transactionHash", (hash: string) => {
        EventBus.$emit("trx-result", { status: "completed", trxId: hash });
      })
      .on("error", (err: MetaError) => {
        metaMaskErrorHandler(err);
      });
  } catch (err) {
    metaMaskErrorHandler(err);
  }
};

export const canTokenPurchaseAmount = async (address: string) => {
  initTokenPresaleContract();
  if (!address) {
    return;
  }
  try {
    const amount = await tokenPresaleContract.methods
      .canPurchaseAmount(address)
      .call();
    return window.web3.utils.fromWei(amount, "ether");
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const tokenPresaleRemaining = async () => {
  return await balanceOf(tokenPresaleContractAddress!);
};

export const tokenRaisedFund = async () => {
  initTokenPresaleContract();
  try {
    const amount = await tokenPresaleContract.methods.accRaisedFund().call();
    return window.web3.utils.fromWei(amount, "ether");
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const LPBalanceOf = async (address: string, pool: number) => {
  if (!address) {
    return;
  }

  initLPContract();
  initLPV2Contract();
  const contract = pool === 0 ? LPContract : LPV2Contract;

  try {
    const amount = await contract.methods.balanceOf(address).call();
    console.log("balance", amount);
    return window.web3.utils.fromWei(amount, "ether");
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const userETHBalance = async (address: string) => {
  if (!address) {
    return;
  }
  try {
    const amount = await window.web3.eth.getBalance(address);
    return window.web3.utils.fromWei(amount, "ether");
  } catch (err) {
    console.log(err);
  }
};

export const LPAllowance = async (address: string, pool: number) => {
  if (!address) {
    return;
  }

  initLPContract();
  initLPV2Contract();
  const contract = pool === 0 ? LPContract : LPV2Contract;
  const masterChefAddress = chooseMasterChefContractAddress(pool);

  try {
    const amount = await contract.methods
      .allowance(address, masterChefAddress)
      .call();
    return window.web3.utils.fromWei(amount, "ether");
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const LPTotalAmount = async (pool: number) => {
  initLPContract();
  initLPV2Contract();
  const contract = pool === 0 ? LPContract : LPV2Contract;
  const masterChefAddress = chooseMasterChefContractAddress(pool);

  try {
    const amount = await contract.methods.balanceOf(masterChefAddress).call();
    return window.web3.utils.fromWei(amount, "ether");
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const LPIncreaseAllowance = async (
  address: string,
  addedValue: number,
  pool: number
) => {
  if (!address) {
    return;
  }

  initLPContract();
  initLPV2Contract();
  const contract = pool === 0 ? LPContract : LPV2Contract;
  const masterChefAddress = chooseMasterChefContractAddress(pool);

  try {
    contract.methods
      .approve(
        masterChefAddress,
        window.web3.utils.toWei(`${addedValue}`, "ether")
      )
      .send({
        from: address,
      })
      .once("transactionHash", (hash: string) => {
        // EventBus.$emit('trx-result', { status: 'completed', trxId: hash });
      })
      .on("error", (error: string) => {
        EventBus.$emit(`LP-approve-status`, "error");
      })
      .then(() => {
        EventBus.$emit(`LP-approve-status`, "completed");
      });
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const LPUserInfo = async (address: string, pool: number) => {
  if (!address) {
    return;
  }
  initMasterChefContract();
  initMasterChefV2Contract();
  initMasterChefV3Contract();
  const contract = chooseMasterChefContract(pool);

  try {
    const res = await contract.methods.userInfo(address).call();
    return {
      amount: window.web3.utils.fromWei(res.amount, "ether"),
      rewardDebt: window.web3.utils.fromWei(res.rewardDebt, "ether"),
      alpacaID: res.alpacaID,
      alpacaEnergy: res.alpacaEnergy,
    };
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const poolInfo = async (pool: number) => {
  initMasterChefContract();
  initMasterChefV2Contract();
  initMasterChefV3Contract();
  const contract = chooseMasterChefContract(pool);
  try {
    const res = await contract.methods.poolInfo().call();
    return res;
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const alpaPerBlock = async () => {
  initAlpaSupplierContract();
  try {
    const amount = await alpaSupplierContract.methods.alpaPerBlock().call();
    return window.web3.utils.fromWei(amount, "ether");
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const exchangeRate = async () => {
  initTokenPresaleContract();
  try {
    const amount = await tokenPresaleContract.methods.exchangeRate().call();
    return amount;
  } catch (err) {
    console.log(err);
  }
};

// Token Presale WL ---------------------
export const tokenPurchaseWL = (amount: number, address: string) => {
  if (!address) {
    return;
  }
  initTokenPresaleWLContract();
  try {
    tokenPresaleWLContract.methods
      .purchase()
      .send({
        from: address,
        value: window.web3.utils.toWei(`${amount}`, "ether"),
      })
      .once("transactionHash", (hash: string) => {
        EventBus.$emit("trx-result", { status: "completed", trxId: hash });
      })
      .on("error", (err: MetaError) => {
        metaMaskErrorHandler(err);
      });
  } catch (err) {
    metaMaskErrorHandler(err);
  }
};

export const canTokenPurchaseAmountWL = async (address: string) => {
  initTokenPresaleWLContract();
  if (!address) {
    return;
  }
  try {
    const amount = await tokenPresaleWLContract.methods
      .canPurchaseAmount(address)
      .call();
    return window.web3.utils.fromWei(amount, "ether");
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const tokenPresaleRemainingWL = async () => {
  return await balanceOf(tokenPresaleWLContractAddress!);
};

export const tokenRaisedFundWL = async () => {
  initTokenPresaleWLContract();
  try {
    const amount = await tokenPresaleWLContract.methods.accRaisedFund().call();
    return window.web3.utils.fromWei(amount, "ether");
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const userETHBalanceWL = async (address: string) => {
  if (!address) {
    return;
  }
  try {
    const amount = await window.web3.eth.getBalance(address);
    return window.web3.utils.fromWei(amount, "ether");
  } catch (err) {
    console.log(err);
  }
};

export const exchangeRateWL = async () => {
  initTokenPresaleWLContract();
  try {
    const amount = await tokenPresaleWLContract.methods.exchangeRate().call();
    return amount;
  } catch (err) {
    console.log(err);
  }
};

export const squadPendingAlpa = async (address: string) => {
  initAlpacaSquadContract();
  if (!address) {
    return;
  }
  try {
    const amount = await alpacaSquadContract.methods
      .pendingAlpa(address)
      .call();
    return window.web3.utils.fromWei(amount, "ether");
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const squadClaim = async (address: string) => {
  if (!address) {
    return;
  }

  initAlpacaSquadContract();

  try {
    alpacaSquadContract.methods
      .claim()
      .send({
        from: address,
      })
      .once("sending", () => {
        EventBus.$emit("trx-result", { status: "loading", trxId: "" });
      })
      .once("transactionHash", (hash: string) => {
        EventBus.$emit("trx-result", { status: "completed", trxId: hash });
      })
      .on("error", (err: MetaError) => {
        metaMaskErrorHandler(err);
      });
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const squadUserInfo = async (address: string) => {
  initAlpacaSquadContract();
  if (!address) {
    return;
  }
  try {
    const res = await alpacaSquadContract.methods.userInfo(address).call();
    return {
      share: res.share,
    };
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const squadRewardInfo = async () => {
  initAlpacaSquadContract();
  try {
    const res = await alpacaSquadContract.methods.rewardInfo().call();
    return {
      accShare: res.accShare,
    };
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const maxAlpacaSquadCount = async () => {
  initAlpacaSquadContract();
  try {
    const amount = await alpacaSquadContract.methods
      .maxAlpacaSquadCount()
      .call();
    return amount;
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const squadRetieve = async (address: string, ids: string[]) => {
  if (!address) {
    return;
  }

  initAlpacaSquadContract();

  try {
    alpacaSquadContract.methods
      .retrieve(ids)
      .send({
        from: address,
      })
      .once("sending", () => {
        EventBus.$emit("trx-result", { status: "loading", trxId: "" });
      })
      .once("transactionHash", (hash: string) => {
        EventBus.$emit("trx-result", { status: "completed", trxId: hash });
      })
      .on("error", (err: MetaError) => {
        metaMaskErrorHandler(err);
      });
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const supplierTotalAllocPoint = async () => {
  initAlpaSupplierContract();
  try {
    const amount = await alpaSupplierContract.methods.totalAllocPoint().call();
    return window.web3.utils.fromWei(amount, "ether");
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const consumerInfo = async (contractAddr: string) => {
  initAlpaSupplierContract();
  try {
    const res = await alpaSupplierContract.methods
      .consumerInfo(contractAddr)
      .call();
    return {
      allocPoint: window.web3.utils.fromWei(res.allocPoint, "ether"),
    };
  } catch (e) {
    // @ts-ignore
    console.log(e);
  }
};

export const totalBurnedAlpa = async () => {
  initAlpaFireContract();
  try {
    const amount = await alpaFireContract.methods.totalBurnedAlpa().call();
    return window.web3.utils.fromWei(amount, "ether");
  } catch (err) {
    console.log(err);
  }
};
